import product1 from "./assets/products/1.jfif";
import product2 from "./assets/products/2.jfif";
import product3 from "./assets/products/3.jfif";
import product4 from "./assets/products/4.jfif";
import product5 from "./assets/products/5.jfif";
import product6 from "./assets/products/6.jfif";
import product7 from "./assets/products/7.webp";
import product8 from "./assets/products/8.jfif";
import product9 from "./assets/products/9.webp";
import product10 from "./assets/products/10.jpg";
import product11 from "./assets/products/11.jpg";
import product12 from "./assets/products/12.jfif";
import product13 from "./assets/products/13.webp";
import product14 from "./assets/products/14.jpg";
import product15 from "./assets/products/15.jfif";
import product16 from "./assets/products2/1.jfif";
import product17 from "./assets/products2/2.jfif";
import product18 from "./assets/products2/3.jfif";
import product19 from "./assets/products2/4.jfif";
import product20 from "./assets/products2/5.jfif";
import product21 from "./assets/products2/6.jfif";
import product22 from "./assets/products2/7.jfif";
import product23 from "./assets/products2/8.jpg";
import product24 from "./assets/products2/9.jpg";
import product25 from "./assets/products2/10.jpg";
import product26 from "./assets/products2/11.jpg";
import product27 from "./assets/products2/12.jpg";
import product28 from "./assets/products2/13.jfif";
import product29 from "./assets/products2/14.jfif";
import product30 from "./assets/products2/15.jfif";
import product31 from "./assets/products3/1.jfif";
import product32 from "./assets/products3/2.jfif";
import product33 from "./assets/products3/3.webp";
import product34 from "./assets/products3/4.jfif";
import product35 from "./assets/products3/5.jfif";
import product36 from "./assets/products3/6.jfif";
import product37 from "./assets/products3/7.webp";
import product38 from "./assets/products3/8.jfif";
import product39 from "./assets/products3/9.jpg";
import product40 from "./assets/products3/10.jfif";
import product41 from "./assets/products3/11.jfif";
import product42 from "./assets/products3/12.jpg";
import product43 from "./assets/products3/13.jfif";
import product44 from "./assets/products3/14.jfif";
import product45 from "./assets/products3/15.jfif";

export const PRODUCTS = [
  {
    id: 1,
    source: "PRODUCTS",
    productName: "Belfoods Spicy Wings 500gr",
    price: 67.500.toFixed(3),
    productImage: product1,
  },
  {
    id: 2,
    source: "PRODUCTS",
    productName: "Belfoods Chicken Nugget 1000gr",
    price: 74.000.toFixed(3),
    productImage: product2,
  },
  {
    id: 3,
    source: "PRODUCTS",
    productName: "Bonanza Beef Bakso Gold 500gr",
    price: 85.000.toFixed(3),
    productImage: product3,
  },
  {
    id: 4,
    source: "PRODUCTS",
    productName: "Belfoods Crispy Karaage 500gr",
    price: 65.000.toFixed(3),
    productImage: product4,
  },
  {
    id: 5,
    source: "PRODUCTS",
    productName: "Belfoods Itaewon Chicken 200gr",
    price: 35.000.toFixed(3),
    productImage: product5,
  },
  {
    id: 6,
    source: "PRODUCTS",
    productName: "Belfoods Cordon Bleu 500gr",
    price: 80.000.toFixed(3),
    productImage: product6,
  },
  {
    id: 7,
    source: "PRODUCTS",
    productName: "Belfoods Gangnam chiken 200gr",
    price: 35.000.toFixed(3),
    productImage: product7,
  },
  {
    id: 8,
    source: "PRODUCTS",
    productName: "Belfoods Royal Cheezy Bites",
    price: 15.000.toFixed(3),
    productImage: product8,
  },
  {
    id: 9,
    source: "PRODUCTS",
    productName: "Belfoods Bakso Ayam Mini 500gr",
    price: 16.000.toFixed(3),
    productImage: product9,
  },
  {
    id: 10,
    source: "PRODUCTS",
    productName: "Belfoods Beef Cocktail 190gr",
    price: 21.000.toFixed(3),
    productImage: product10,
  },{
    id: 11,
    source: "PRODUCTS",
    productName: "Belfoods Crispy Chicken Burger 315gr",
    price: 17.605.toFixed(3),
    productImage: product11,
  },{
    id: 12,
    source: "PRODUCTS",
    productName: "Belfoods Favorite Chicken Stick 500gr",
    price: 38.830.toFixed(3),
    productImage: product12,
  },
  {
    id: 13,
    source: "PRODUCTS",
    productName: "Kanzler Nugget Crispy 120gr",
    price: 16.150.toFixed(3),
    productImage: product13,
  },
  {
    id: 14,
    source: "PRODUCTS",
    productName: "Kanzler Beef cocktail 500gr",
    price: 50.999.toFixed(3),
    productImage: product14,
  },
  {
    id: 15,
    source: "PRODUCTS",
    productName: "Kanzler Bockwurst 360gr",
    price: 40.853.toFixed(3),
    productImage: product15,
  },
];

export const PRODUCTS2 = [
  {
    id: 16,
    source: "PRODUCTS2",
    productName: "Rejuve i.Glow",
    price: 51.300.toFixed(3),
    productImage: product16,
  },
  {
    id: 17,
    source: "PRODUCTS2",
    productName: "Rejuve u.Glow",
    price: 51.300.toFixed(3),
    productImage: product17,
  },
  {
    id: 18,
    source: "PRODUCTS2",
    productName: "Rejuve Green Glory",
    price: 54.450.toFixed(3),
    productImage: product18,
  },
  {
    id: 19,
    source: "PRODUCTS2",
    productName: "Rejuve Asian Green",
    price: 50.250.toFixed(3),
    productImage: product19,
  },
  {
    id: 20,
    source: "PRODUCTS2",
    productName: "Rejuve Beat That",
    price: 50.250.toFixed(3),
    productImage: product20,
  },
  {
    id: 21,
    source: "PRODUCTS2",
    productName: "Duta Pineapple Juice 250ml x 2 pcs",
    price: 23.000.toFixed(3),
    productImage: product21,
  },
  {
    id: 22,
    source: "PRODUCTS2",
    productName: "Hometown Fresh Milk Susu Segar 450 ML",
    price: 21.000.toFixed(3),
    productImage: product22,
  },
  {
    id: 23,
    source: "PRODUCTS2",
    productName: "Fanta Strawberry Pet 1.5 Litre",
    price: 13.000.toFixed(3),
    productImage: product23,
  },
  {
    id: 24,
    source: "PRODUCTS2",
    productName: "Coca-Cola Original - Kaleng 250ml - x6 Pcs",
    price: 34.200.toFixed(3),
    productImage: product24,
  },
  {
    id: 25,
    source: "PRODUCTS2",
    productName: "Bear Brand Milk White Tea 140ml 6 pcs",
    price: 50.692.toFixed(3),
    productImage: product25,
  },{
    id: 26,
    source: "PRODUCTS2",
    productName: "Bear Brand Susu Steril 189ml x 8pcs",
    price: 77.700.toFixed(3),
    productImage: product26,
  },{
    id: 27,
    source: "PRODUCTS2",
    productName: "Pocari Sweat 900 ml Single",
    price: 12.200.toFixed(3),
    productImage: product27,
  },{
    id: 28,
    source: "PRODUCTS2",
    productName: "DS Mizone Isotonik Activ Lychee Lemon 500ml",
    price: 3.988.toFixed(3),
    productImage: product28,
  },{
    id: 29,
    source: "PRODUCTS2",
    productName: "Fanta Air Minuman Soda - Botol 250ml x 12pcs",
    price: 42.720.toFixed(3),
    productImage: product29,
  },{
    id: 30,
    source: "PRODUCTS2",
    productName: "Addictea Milktea Rasa Thaitea 240ml",
    price: 15.840.toFixed(3),
    productImage: product30,
  },
];

export const PRODUCTS3 = [
  {
    id: 31,
    source: "PRODUCTS3",
    productName: "Duta Chocolate Banana Chips 35gr x 4 pcs",
    price: 42.000.toFixed(3),
    productImage: product31,
  },
  {
    id: 32,
    source: "PRODUCTS3",
    productName: "Duta Chili Lemon Banana Chips 35gr x 2 pcs",
    price: 21.000.toFixed(3),
    productImage: product32,
  },
  {
    id: 33,
    source: "PRODUCTS3",
    productName: "Sunpride Lyfe Cavendish Banana Chips BBQ 55 gr",
    price: 10.000.toFixed(3),
    productImage: product33,
  },
  {
    id: 34,
    source: "PRODUCTS3",
    productName: "Sunpride Lyfe Cavendish Banana Chips Lemon 55 gr",
    price: 10.000.toFixed(3),
    productImage: product34,
  },
  {
    id: 35,
    source: "PRODUCTS3",
    productName: "Fiesta French Fries Batter Coated",
    price: 28.000.toFixed(3),
    productImage: product35,
  },
  {
    id: 36,
    source: "PRODUCTS3",
    productName: "Maicih Keripik Singkong Level 10",
    price: 18.000.toFixed(3),
    productImage: product36,
  },
  {
    id: 37,
    source: "PRODUCTS3",
    productName: "Chocomory Chocolate Pie isi 20 500g",
    price: 88.000.toFixed(3),
    productImage: product37,
  },
  {
    id: 38,
    source: "PRODUCTS3",
    productName: "Maicih Basreng (Level 10) 100g",
    price: 18.000.toFixed(3),
    productImage: product38,
  },
  {
    id: 39,
    source: "PRODUCTS3",
    productName: "Wonhae Topokki Snack Sweet & Spicy",
    price: 9.900.toFixed(3),
    productImage: product39,
  },
  {
    id: 40,
    source: "PRODUCTS3",
    productName: "Lidi Geli - Mie Lidi Rasa Spicy 50gr",
    price: 9.500.toFixed(3),
    productImage: product40,
  },{
    id: 41,
    source: "PRODUCTS3",
    productName: "BonCabe Snack Makaroni Krispi Level 50 (5pcs)",
    price: 9.900.toFixed(3),
    productImage: product41,
  },{
    id: 42,
    source: "PRODUCTS3",
    productName: "Kusuka Snack Emping 40 gr",
    price: 8.300.toFixed(3),
    productImage: product42,
  },{
    id: 43,
    source: "PRODUCTS3",
    productName: "Lemonilo Chimi Keripik Ubi Rasa Jagung Bakar",
    price: 9.000.toFixed(3),
    productImage: product43,
  },{
    id: 44,
    source: "PRODUCTS3",
    productName: "Lemonilo Chimi Keripik Ubi Rasa Jagung Balado",
    price: 9.000.toFixed(3),
    productImage: product44,
  },{
    id: 45,
    source: "PRODUCTS3",
    productName: "Lemonilo Sola Farm Beef Steak 45gr"  ,
    price: 11.000.toFixed(3),
    productImage: product45,
  },
];